import { combineReducers } from '@reduxjs/toolkit';

import applicationReducer from './applicationReducer';
import userReducer from "./userReducer";
import menuReducer from './menuReducer';
import sessionReducer from './sessionReducer';
import { accountDashboardReducer, memberDashboardReducer } from "./dashboardReducer";
import accountSummaryReducer from './accountSummaryReducer';
import accountHistoryReducer from './accountHistoryReducer';
import storageHistoryReducer from './storageHistoryReducer';
import pushHistoryReducer from './pushHistoryReducer';
import eventHistoryReducer from './eventHistoryReducer';
import platformHistoryReducer from './platformHistoryReducer';
import memberReducer from './memberReducer';

export const LOGOUT_ACTION = 'LOGOUT';

const rootReducer = combineReducers({
    application: applicationReducer,
    user: userReducer,
    menu: menuReducer,
    session: sessionReducer,
    accountDashboard: accountDashboardReducer,
    memberDashboard: memberDashboardReducer,
    accountSummary: accountSummaryReducer,
    accountHistory: accountHistoryReducer,
    storageHistory: storageHistoryReducer,
    pushHistory: pushHistoryReducer,
    eventHistory: eventHistoryReducer,
    platformHistory: platformHistoryReducer,
    member: memberReducer,
});

const reducer = (state, action) => {
    if (action.type === LOGOUT_ACTION) {
        return rootReducer({application: state.application}, action);
    }

    return rootReducer(state, action);
}

export default reducer;
